/**
 * ReportsHarvestInspectionsTableRowLink Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Workspaces
import { makeSelectQueryStringNumberValue } from '../../../../../../../../workspaces/react-router-selectors';

type State = *;

interface Props {
    eventId?: number;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectEventId = (state: State, props: Props) => props.eventId;

const makeSelectIsActive = () =>
    createDeepEqualSelector(
        [makeSelectQueryStringNumberValue('selectedEvent'), selectEventId],
        (selectedEventState, eventIdState) =>
            !!(selectedEventState === eventIdState)
    );

export { makeSelectIsActive };
